<template>
<div class="chapter">
<div class="inner_page">
<div class="boxch">
<h1 class="fm-title" id="fm-2"><a id="page_vii"><strong>Abbreviations</strong></a></h1><a id="page_vii">
</a></div><a id="page_vii">
<table>
<tbody>
<tr>
<td class="td1">
<p class="t-left1">ANF</p></td>
<td class="td2">
<p class="t-hang">The Ante-Nicene Fathers</p></td>
</tr>
<tr>
<td class="td1">
<p class="t-left1">BAGD</p></td>
<td class="td2">
<p class="t-hang">W. Bauer, W. F. Arndt, F. W. Gingrich, and F. W. Danker, <em>A Greek-English Lexicon of the New Testament and Other Early Christian Literature</em></p></td>
</tr>
<tr>
<td class="td1">
<p class="t-left1">BDF</p></td>
<td class="td2">
<p class="t-hang">F. Blass, A. Debrunner, and R. W. Funk, <em>A Greek Grammar of the New Testament</em></p></td>
</tr>
<tr>
<td class="td1">
<p class="t-left1"><em>CBQ</em></p></td>
<td class="td2">
<p class="t-hang"><em>Catholic Biblical Quarterly</em></p></td>
</tr>
<tr>
<td class="td1">
<p class="t-left1"><em>DB</em></p></td>
<td class="td2">
<p class="t-hang">James Hastings (ed.), <em>Dictionary of the Bible</em> (rev. by F. C. Grant and H. H. Rowley)</p></td>
</tr>
<tr>
<td class="td1">
<p class="t-left1"><em>ET</em></p></td>
<td class="td2">
<p class="t-hang"><em>Expository Times</em></p></td>
</tr>
<tr>
<td class="td1">
<p class="t-left1">GNB</p></td>
<td class="td2">
<p class="t-hang">Good News Bible</p></td>
</tr>
<tr>
<td class="td1">
<p class="t-left1"><em>IB</em></p></td>
<td class="td2">
<p class="t-hang"><em>Interpreter’s Bible</em></p></td>
</tr>
<tr>
<td class="td1">
<p class="t-left1"><em>IBD</em></p></td>
<td class="td2">
<p class="t-hang"><em>Illustrated Bible Dictionary</em></p></td>
</tr>
<tr>
<td class="td1">
<p class="t-left1"><em>IDB</em></p></td>
<td class="td2">
<p class="t-hang"><em>Interpreter’s Dictionary of the Bible</em></p></td>
</tr>
<tr>
<td class="td1">
<p class="t-left1"><em>ISBE</em></p></td>
<td class="td2">
<p class="t-hang"><em>International Standard Bible Encyclopedia</em></p></td>
</tr>
<tr>
<td class="td1">
<p class="t-left1">JB</p></td>
<td class="td2">
<p class="t-hang">Jerusalem Bible</p></td>
</tr>
<tr>
<td class="td1">
<p class="t-left1"><em>JBL</em></p></td>
<td class="td2">
<p class="t-hang"><em>Journal of Biblical Literature</em></p></td>
</tr>
<tr>
<td class="td1">
<p class="t-left1"><em>JTS</em></p></td>
<td class="td2">
<p class="t-hang"><em>Journal of Theological Studies</em></p></td>
</tr>
<tr>
<td class="td1">
<p class="t-left1">LB</p></td>
<td class="td2">
<p class="t-hang">Living Bible</p></td>
</tr>
<tr>
<td class="td1">
<p class="t-left1">LXX</p></td>
<td class="td2">
<p class="t-hang">The Septuagint</p></td>
</tr>
<tr>
<td class="td1">
<p class="t-left1">NEB</p></td>
<td class="td2">
<p class="t-hang">New English Bible</p></td>
</tr>
<tr>
<td class="td1">
<p class="t-left1"><em>NIDNTT</em></p></td>
<td class="td2">
<p class="t-hang"><em>New International Dictionary of New Testament Studies</em></p></td>
</tr>
<tr>
<td class="td1">
<p class="t-left1">NIV</p></td>
<td class="td2">
<p class="t-hang">New International Version</p></td>
</tr>
<tr>
<td class="td1">
<p class="t-left1"><em>NovT</em></p></td>
<td class="td2">
<p class="t-hang"><em>Novum Testamentum</em></p></td>
</tr>
<tr>
<td class="td1">
<p class="t-left1"><em>NTS</em></p></td>
<td class="td2">
<p class="t-hang"><em>New Testament Studies</em></p></td>
</tr>
<tr>
<td class="td1">
<p class="t-left1">RSV</p></td>
<td class="td2">
<p class="t-hang">Revised Standard Version</p></td>
</tr>
<tr>
<td class="td1">
<p class="t-left1">SBk</p></td>
<td class="td2">
<p class="t-hang">H. Strack and P. Billerbeck, <em>Kommentar zum Neuen Testament</em></p></td>
</tr>
<tr>
<td class="td1">
<p class="t-left1"><em>SE</em></p></td>
<td class="td2">
<p class="t-hang"><em>Studia Evangelica</em></p></td>
</tr>
<tr>
<td class="td1">
<p class="t-left1"><em>TDNT</em></p></td>
<td class="td2">
<p class="t-hang"><em>Theological Dictionary of the New Testament</em></p></td>
</tr>
</tbody>
</table>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 006_Abbre.vue?a0411a3a